import { defineComponent as y, computed as E, onMounted as v, onBeforeUnmount as b, openBlock as M, createElementBlock as _ } from "vue";
/* empty css         */
import { Editor as P } from "./index273.js";
const $ = ["innerHTML"], k = /* @__PURE__ */ y({
  __name: "BaseToastEditorContent",
  props: {
    modelValue: {},
    onlyPTag: { type: Boolean, default: !1 }
  },
  setup(f) {
    const g = (e) => {
      if (!e) return "";
      if (typeof document < "u") {
        const a = document.createElement("div");
        a.innerHTML = e;
        const l = a.querySelectorAll("p");
        return Array.from(l).filter((n) => !n.closest("table, blockquote, li")).map((n) => n.outerHTML).join("");
      }
      const r = e.replace(/<table[\s\S]*?<\/table>/gi, ""), t = /<p[^>]*>[\s\S]*?<\/p>/gi, s = r.match(t);
      return s ? s.join("") : "";
    }, p = f;
    let o = null;
    const u = () => {
      if (o) return;
      const e = document.createElement("div");
      e.style.display = "none", document.body.appendChild(e), o = new P({
        el: e,
        previewStyle: "vertical",
        height: "1px",
        initialValue: "",
        usageStatistics: !1
      });
    }, T = (e) => {
      if (!e || e.trim() === "") return "";
      const r = /* @__PURE__ */ new Map();
      let t = e;
      t = t.replace(/\\r\\n/g, `
`).replace(/\r\n/g, `
`).replace(/\\n/g, `
`);
      let s = 0;
      const a = () => `⟦KEEP${s++}⟧`;
      if (t = t.replace(
        /<(span|a)(\s[^>]*style="[^"]*"[^>]*)>([\s\S]*?)<\/\1>/gi,
        (l, n, i, c) => {
          const d = a(), m = a();
          return r.set(d, `<${n}${i}>`), r.set(m, `</${n}>`), `${d}${c}${m}`;
        }
      ), t = t.replace(/<br\s*\/?>/gi, `
`), o || u(), o)
        try {
          o.setMarkdown(t), t = o.getHTML();
        } catch {
          return e;
        }
      return r.forEach((l, n) => {
        const i = [
          n,
          n.replace(/⟦/g, "&amp;#10214;").replace(/⟧/g, "&amp;#10215;"),
          n.replace(/⟦/g, "&#10214;").replace(/⟧/g, "&#10215;")
        ];
        for (const c of i)
          if (t.includes(c)) {
            t = t.split(c).join(l);
            break;
          }
      }), t;
    }, h = E(() => {
      const e = T(p.modelValue ?? "");
      return p.onlyPTag ? g(e) : e;
    });
    return v(() => {
      u();
    }), b(() => {
      o && (o.destroy(), o = null);
    }), (e, r) => (M(), _("div", {
      class: "toastui-editor-contents",
      innerHTML: h.value
    }, null, 8, $));
  }
});
export {
  k as default
};
